/*!
 * artmie-wishlist.js v3 — localStorage wishlist + cart integration. (SK / Slovak)
 */
(function () {
  'use strict';
  try { console.log('%c[ARTMIE WL v4] loaded — '+location.host, 'background:#feb21f;color:#000;padding:2px 6px;border-radius:3px;font-weight:bold'); } catch(e){}

  // i18n: detect DE/AT locale via <html lang>, request path or hostname
  function _isDe() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('de') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/de-at') === 0 || path.indexOf('/de/') === 0 || path === '/de') return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.at') >= 0 || host.indexOf('artmie.de') >= 0) return true;
    } catch (e) {}
    return false;
  }
  /* ARTMIE_WISHLIST_SI_I18N 2026-05-16 — Slovenian locale support for the SI market.
     Previously: only DE/AT had translations; SI users saw raw Slovak strings like "Do košíka". */
  function _isSi() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('sl') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/sl-si') === 0 || path.indexOf('/sk-si') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.si') >= 0) return true;
    } catch (e) {}
    return false;
  }
  /* ARTMIE_WISHLIST_IT_I18N 2026-05-19 — Italian locale support for the IT market.
     Previously: IT users saw a constant flash between Slovak (from setInterval paint
     every 1500ms emitting raw SK strings) and Italian (from the IT rewriter rewriting
     them on the next tick). Strings below MATCH the rewriter's TEXT_REWRITES output
     verbatim so paint + rewriter agree on the final HTML and the innerHTML guard at
     renderPage no longer re-renders on each interval tick. */
  function _isIt() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('it') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/it-it') === 0 || path.indexOf('/sk-it') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.it') >= 0) return true;
    } catch (e) {}
    return false;
  }
  /* ARTMIE_WISHLIST_HR_I18N 2026-05-19 — Croatian locale, same fix as IT. */
  function _isHr() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('hr') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/hr-hr') === 0 || path.indexOf('/sk-hr') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.hr') >= 0) return true;
    } catch (e) {}
    return false;
  }
  /* ARTMIE_WISHLIST_GR_I18N 2026-05-19 — Greek locale, same fix as IT. */
  function _isGr() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('el') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/el-gr') === 0 || path.indexOf('/sk-gr') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.gr') >= 0) return true;
    } catch (e) {}
    return false;
  }
  /* ARTMIE_WISHLIST_BG_I18N 2026-06-04 — Bulgarian locale, same shape as IT/HR/GR. */
  function _isBg() {
    try {
      var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (lang.indexOf('bg') === 0) return true;
      var path = (location.pathname || '').toLowerCase();
      if (path.indexOf('/bg-bg') === 0 || path.indexOf('/sk-bg') === 0) return true;
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('artmie.bg') >= 0) return true;
    } catch (e) {}
    return false;
  }
  var I18N_DE = {
    'Vyber variant': 'Variante wählen',
    'Zavrieť': 'Schließen',
    'Pridať všetky do košíka': 'Alle in den Warenkorb',
    'Odstrániť': 'Entfernen',
    'Znížiť': 'Verringern',
    'Zvýšiť': 'Erhöhen',
    'Do košíka': 'In den Warenkorb',
    'Produkt už nie je dostupný': 'Produkt nicht mehr verfügbar',
    'Pridávam…': 'Wird hinzugefügt…',
    'Produkt je vypredaný': 'Produkt ausverkauft',
    'Váš zoznam želaní je prázdny.': 'Ihre Wunschliste ist leer.',
    'Prezrieť produkty': 'Produkte ansehen',
    'žiadny variant': 'keine Variante'
  };
  var I18N_SI = {
    'Vyber variant': 'Izberi različico',
    'Zavrieť': 'Zapri',
    'Pridať všetky do košíka': 'Dodaj vse v košarico',
    'Odstrániť': 'Odstrani',
    'Znížiť': 'Zmanjšaj',
    'Zvýšiť': 'Povečaj',
    'Do košíka': 'V košarico',
    'Produkt už nie je dostupný': 'Izdelek ni več na voljo',
    'Pridávam…': 'Dodajam…',
    'Produkt je vypredaný': 'Izdelek je razprodan',
    'Váš zoznam želaní je prázdny.': 'Vaš seznam želja je prazen.',
    'Prezrieť produkty': 'Prebrskaj izdelke',
    'žiadny variant': 'brez različice'
  };
  /* Italian strings — match the IT rewriter's TEXT_REWRITES values so paint and
     rewrite converge, ending the flash loop. */
  var I18N_IT = {
    'Vyber variant': 'Scegli variante',
    'Zavrieť': 'Chiudi',
    'Pridať všetky do košíka': 'Aggiungi tutti al carrello',
    'Odstrániť': 'Rimuovi',
    'Znížiť': 'Diminuisci',
    'Zvýšiť': 'Aumenta',
    'Do košíka': 'Al carrello',
    'Produkt už nie je dostupný': 'Prodotto non più disponibile',
    'Pridávam…': 'Aggiungo…',
    'Produkt je vypredaný': 'Prodotto esaurito',
    'Váš zoznam želaní je prázdny.': 'La tua lista dei desideri è vuota.',
    'Prezrieť produkty': 'Sfoglia i prodotti',
    'žiadny variant': 'nessuna variante'
  };
  /* Croatian strings — match HR rewriter's TEXT_REWRITES output where present. */
  var I18N_HR = {
    'Vyber variant': 'Odaberi varijantu',
    'Zavrieť': 'Zatvori',
    'Pridať všetky do košíka': 'Dodaj sve u košaricu',
    'Odstrániť': 'Ukloni',
    'Znížiť': 'Smanji',
    'Zvýšiť': 'Povećaj',
    'Do košíka': 'U košaricu',
    'Produkt už nie je dostupný': 'Proizvod više nije dostupan',
    'Pridávam…': 'Dodajem…',
    'Produkt je vypredaný': 'Proizvod je rasprodan',
    'Váš zoznam želaní je prázdny.': 'Vaš popis želja je prazan.',
    'Prezrieť produkty': 'Pregledaj proizvode',
    'žiadny variant': 'nema varijante'
  };
  /* Greek strings — match GR rewriter's TEXT_REWRITES output where present. */
  var I18N_GR = {
    'Vyber variant': 'Επιλέξτε παραλλαγή',
    'Zavrieť': 'Κλείσιμο',
    'Pridať všetky do košíka': 'Προσθήκη όλων στο καλάθι',
    'Odstrániť': 'Αφαίρεση',
    'Znížiť': 'Μείωση',
    'Zvýšiť': 'Αύξηση',
    'Do košíka': 'Στο καλάθι',
    'Produkt už nie je dostupný': 'Το προϊόν δεν είναι πλέον διαθέσιμο',
    'Pridávam…': 'Προσθήκη…',
    'Produkt je vypredaný': 'Το προϊόν εξαντλήθηκε',
    'Váš zoznam želaní je prázdny.': 'Η λίστα επιθυμιών σας είναι άδεια.',
    'Prezrieť produkty': 'Δείτε τα προϊόντα',
    'žiadny variant': 'χωρίς παραλλαγή'
  };
  /* Bulgarian strings — match BG rewriter's TEXT_REWRITES output where present. */
  var I18N_BG = {
    'Vyber variant': 'Изберете вариант',
    'Zavrieť': 'Затвори',
    'Pridať všetky do košíka': 'Добави всички в количката',
    'Odstrániť': 'Премахни',
    'Znížiť': 'Намали',
    'Zvýšiť': 'Увеличи',
    'Do košíka': 'В количката',
    'Produkt už nie je dostupný': 'Продуктът вече не е наличен',
    'Pridávam…': 'Добавям…',
    'Produkt je vypredaný': 'Продуктът е изчерпан',
    'Váš zoznam želaní je prázdny.': 'Вашият списък с желания е празен.',
    'Prezrieť produkty': 'Разгледайте продуктите',
    'žiadny variant': 'без вариант'
  };
  function _t(s) {
    if (_isIt()) return I18N_IT[s] || s;
    if (_isHr()) return I18N_HR[s] || s;
    if (_isGr()) return I18N_GR[s] || s;
    if (_isBg()) return I18N_BG[s] || s;
    if (_isSi()) return I18N_SI[s] || s;
    if (_isDe()) return I18N_DE[s] || s;
    return s;
  }
  function _tAdded(added, failed) {
    if (_isIt()) return failed ? ('Aggiunti: ' + added + ' (errori: ' + failed + ')') : ('Tutti aggiunti ✓');
    if (_isHr()) return failed ? ('Dodano: ' + added + ' (greške: ' + failed + ')') : ('Sve dodano ✓');
    if (_isGr()) return failed ? ('Προστέθηκαν: ' + added + ' (σφάλματα: ' + failed + ')') : ('Προστέθηκαν όλα ✓');
    if (_isBg()) return failed ? ('Добавени: ' + added + ' (грешки: ' + failed + ')') : ('Всички добавени ✓');
    if (_isSi()) return failed ? ('Dodano ' + added + ' (napake: ' + failed + ')') : ('Vse dodano ✓');
    if (_isDe()) return failed ? ('Hinzugefügt: ' + added + ' (Fehler: ' + failed + ')') : ('Alle hinzugefügt ✓');
    return failed ? ('Pridané ' + added + ' (chyby: ' + failed + ')') : ('Všetky pridané ✓');
  }

  var KEY = 'artmie_wishlist_v1';
  var painting = false;
  var productCache = {};
  /* ARTMIE_WISHLIST_UNAVAIL_CACHE 2026-05-19 — track handles known to be
     unavailable (404 from /products/<handle>.js). Without this, renderCard
     emits the default "Al carrello" button every paint, hydrateCard rewrites
     it to "Non disponibile", and the 1.5s setInterval makes them flash. With
     this Set, renderCard emits the disabled markup directly so paint output
     converges with hydrateCard's output and the innerHTML guard stops the
     flash on the second tick. */
  var unavailableHandles = {};
  function _tNotAvail() {
    return _isIt() ? 'Non disponibile'
         : _isHr() ? 'Nedostupno'
         : _isGr() ? 'Μη διαθέσιμο'
         : _isBg() ? 'Не е налично'
         : _isSi() ? 'Ni na voljo'
         : _isDe() ? 'Nicht verfügbar'
         : 'Nedostupné';
  }

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paint();
  }
  function has(handle) { return load().some(function (i) { return i.handle === handle; }); }
  function toggle(item) {
    var list = load();
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx >= 0) list.splice(idx, 1);
    else list.unshift({
      handle: item.handle,
      title: item.title,
      url: item.url,
      image: item.image,
      price: item.price,
      brand: item.brand || '',
      rating: item.rating || '',
      ratingCount: item.ratingCount || '',
      variantId: item.variantId || null,
      qty: 1,
      added: Date.now()
    });
    save(list);
    return idx < 0;
  }
  function updateItem(handle, patch) {
    var list = load();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx < 0) return;
    list[idx] = Object.assign({}, list[idx], patch);
    save(list);
  }

  // Strip Shopify's bogus "Default Title" placeholder variant when real named variants exist.
  // Otherwise the variant picker offers a "main product" entry that has no color/option chosen.
  function stripDefaultVariant(p) {
    if (!p || !p.variants || p.variants.length <= 1) return p;
    var real = p.variants.filter(function (v) {
      if (v.title === 'Default Title' || v.title === 'Default') return false;
      if (v.options && v.options.length === 1 && (v.options[0] === 'Default Title' || v.options[0] === 'Default')) return false;
      return true;
    });
    if (real.length > 0) p.variants = real;
    return p;
  }
  function fetchProduct(handle) {
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p) { stripDefaultVariant(p); productCache[handle] = p; }
        else { productCache[handle] = null; unavailableHandles[handle] = true; }
        return p;
      })
      .catch(function () { productCache[handle] = null; unavailableHandles[handle] = true; return null; });
  }

  function extractSrc(v) {
    if (!v) return '';
    if (typeof v === 'string') return v;
    if (v.src) return v.src;
    if (v.url) return v.url;
    if (v.preview_image && v.preview_image.src) return v.preview_image.src;
    if (v.image && (v.image.src || v.image.url)) return v.image.src || v.image.url;
    return '';
  }
  function variantImage(product, variant) {
    var src = extractSrc(variant && variant.featured_image);
    if (src) return sizeImg(src, 200);
    src = extractSrc(variant && variant.featured_media);
    if (src) return sizeImg(src, 200);
    src = extractSrc(product && product.featured_image);
    if (src) return sizeImg(src, 200);
    if (product && product.media && product.media[0]) {
      src = extractSrc(product.media[0]);
      if (src) return sizeImg(src, 200);
    }
    if (product && product.images && product.images[0]) {
      src = extractSrc(product.images[0]);
      if (src) return sizeImg(src, 200);
    }
    return '';
  }
  function sizeImg(url, size) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  // SK: Euro (EUR). Display "10,00 €".
  function formatMoney(raw) {
    if (raw == null) return '';
    var n;
    if (typeof raw === 'string') {
      if (raw.indexOf('.') >= 0 || raw.indexOf(',') >= 0) {
        n = parseFloat(raw.replace(',', '.'));
      } else {
        n = parseInt(raw, 10) / 100;
      }
    } else if (typeof raw === 'number') {
      n = raw / 100;
    } else {
      return '';
    }
    if (!isFinite(n)) return '';
    var fixed = n.toFixed(2).replace('.', ',');
    return fixed + ' €';
  }

  function cleanVariantTitle(t, productTitle) {
    if (!t) return productTitle || '';
    var s = String(t).trim();
    if (s === 'Default Title' || s === 'Default') return productTitle || '';
    s = s.replace(/^Default Title\s*\/\s*/, '').replace(/\s*\/\s*Default Title$/, '');
    return s || (productTitle || '');
  }

  // Inject a wishlist heart into every product card that doesn't already have one.
  // Needed because the user can configure the card with blocks that omit
  // .product-card-actions (the natural home for the heart). This guarantees
  // the heart appears in the upper-right corner of every card on every page.
  var HEART_SVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  function injectCardHearts() {
    // STEP 1: Relocate hearts stuck inside hidden .product-card-actions containers.
    // Horizon hides .product-card-actions via --quick-add-display:none when quick_add is off,
    // which hides our heart even with display:flex !important on the child.
    var stuck = document.querySelectorAll('.product-card-actions [data-wishlist-toggle]');
    for (var s = 0; s < stuck.length; s++) {
      var h = stuck[s];
      var card = h.closest('product-card, .product-card');
      if (card && h.parentElement !== card) {
        h.classList.remove('product-card-actions__button', 'product-card-actions__button--wishlist');
        h.classList.add('artmie-wl-injected-heart');
        h.innerHTML = HEART_SVG;
        if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
        card.appendChild(h);
      }
    }

    // STEP 2: Inject hearts into product cards that have no heart at all.
    // STRICT: only target real product card elements (NOT cart drawer rows, NOT generic
    // ancestors). Earlier broad fallback put hearts into <td class="cart-items__media">.
    var cards = document.querySelectorAll('product-card, .product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('[data-wishlist-toggle]')) continue;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) continue;
      var handle = m[1];
      var titleEl = card.querySelector('.product-card__title, .product-title, h3, h2, [class*="title"]');
      var title = titleEl ? titleEl.textContent.trim().replace(/\s+/g, ' ') : '';
      var img = card.querySelector('img');
      var image = img ? (img.currentSrc || img.src || '') : '';
      var priceEl = card.querySelector('.price__regular, .price-item--regular, .price, [class*="price"]');
      var price = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'artmie-wl-injected-heart';
      btn.setAttribute('data-wishlist-toggle', '');
      btn.setAttribute('data-wishlist-handle', handle);
      btn.setAttribute('data-wishlist-title', title);
      btn.setAttribute('data-wishlist-url', '/products/' + handle);
      btn.setAttribute('data-wishlist-image', image);
      btn.setAttribute('data-wishlist-price', price);
      btn.setAttribute('aria-label', 'Wishlist');
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = HEART_SVG;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.appendChild(btn);
    }
  }

  // PDP: inject a square heart button next to the Add-to-Cart button on the product detail page.
  // Detects PDP via location.pathname (/products/HANDLE). Pulls product data from the page.
  function injectPdpHeart() {
    var pathMatch = (location.pathname || '').match(/^\/products\/([^/?#]+)/);
    if (!pathMatch) return;
    var handle = pathMatch[1];
    // Don't double-inject
    if (document.querySelector('.artmie-wl-pdp-heart')) return;
    // Find the row that holds the qty + ATC. Try multiple anchors for theme variation.
    var atcWrap = document.querySelector('.artmie-pdp__atc-wrap, add-to-cart-component:not(product-card add-to-cart-component)');
    var formRow = atcWrap && atcWrap.closest('.artmie-pdp__form-row, .product-form, .product__form, [class*="form-row"], form');
    var anchor = formRow || atcWrap;
    if (!anchor || !atcWrap) return;
    // Pull product info from page
    var title = (document.querySelector('h1')?.textContent || document.title || '').trim().replace(/\s*[–|]\s*[^|–]+$/, '').slice(0, 200);
    var img = document.querySelector('main img, [class*="gallery"] img, [class*="product"] img');
    var image = img ? (img.currentSrc || img.src || '') : '';
    var priceEl = document.querySelector('[class*="price__current"], [class*="price-item--regular"], .price__regular, [class*="price"]:not(:empty)');
    var price = priceEl ? priceEl.textContent.trim().replace(/\s+/g,' ').slice(0, 50) : '';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'artmie-wl-pdp-heart';
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-wishlist-handle', handle);
    btn.setAttribute('data-wishlist-title', title);
    btn.setAttribute('data-wishlist-url', '/products/' + handle);
    btn.setAttribute('data-wishlist-image', image);
    btn.setAttribute('data-wishlist-price', price);
    btn.setAttribute('aria-label', 'Wishlist');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = HEART_SVG;

    // Insert as sibling next to ATC wrap (after it), so the form row becomes [qty][ATC][heart]
    if (atcWrap.parentElement) {
      atcWrap.parentElement.insertBefore(btn, atcWrap.nextSibling);
    }
  }

  function paint() {
    if (painting) return;
    painting = true;
    try {
      injectCardHearts();
      injectPdpHeart();
      var list = load();
      var saved = {};
      for (var i = 0; i < list.length; i++) saved[list[i].handle] = true;

      var buttons = document.querySelectorAll('[data-wishlist-toggle]');
      for (var j = 0; j < buttons.length; j++) {
        var btn = buttons[j];
        var handle = btn.getAttribute('data-wishlist-handle');
        if (!handle) continue;
        var wanted = !!saved[handle];
        if (wanted !== btn.classList.contains('is-wished')) btn.classList.toggle('is-wished', wanted);
        var prev = btn.getAttribute('aria-pressed') === 'true';
        if (wanted !== prev) btn.setAttribute('aria-pressed', wanted ? 'true' : 'false');
      }

      var n = list.length;
      var counters = document.querySelectorAll('[data-wishlist-count]');
      for (var k = 0; k < counters.length; k++) {
        var el = counters[k];
        var newText = String(n);
        if (el.textContent !== newText) el.textContent = newText;
        var zero = n === 0;
        if (zero !== el.classList.contains('is-zero')) el.classList.toggle('is-zero', zero);
      }

      var host = document.getElementById('artmie-wishlist-page');
      if (host) renderPage(host, list);
    } finally {
      painting = false;
    }
  }

  function renderPage(host, list) {
    if (!list.length) {
      var emptyHtml = '<div class="artmie-wishlist-empty"><p>' +
        escapeHtml(host.getAttribute('data-empty-text') || _t('Váš zoznam želaní je prázdny.')) +
        '</p><a href="/collections/all" class="button button-primary">' +
        escapeHtml(host.getAttribute('data-browse-text') || _t('Prezrieť produkty')) +
        '</a></div>';
      if (host.innerHTML !== emptyHtml) host.innerHTML = emptyHtml;
      return;
    }

    /* ARTMIE_WISHLIST_COUNT_SI_I18N 2026-05-16 — Slovenian uses singular/dual/few/many forms.
       Without this branch the counter rendered "1 produktov" (Slovak), and the SI rewriter
       briefly fixed it on each paint, causing a visible SK↔SL flicker.
       2026-05-19 — same flash bug fixed for IT (Italian uses singular/plural). */
    function _siCountWord(n){
      if (n === 1) return ' izdelek';
      if (n === 2) return ' izdelka';
      if (n === 3 || n === 4) return ' izdelki';
      return ' izdelkov';
    }
    function _itCountWord(n){
      return n === 1 ? ' prodotto' : ' prodotti';
    }
    /* Croatian: 1 → proizvod; 2–4 → proizvoda (paucal); 5+ → proizvoda. */
    function _hrCountWord(n){
      return n === 1 ? ' proizvod' : ' proizvoda';
    }
    /* Greek: 1 → προϊόν; 2+ → προϊόντα. */
    function _grCountWord(n){
      return n === 1 ? ' προϊόν' : ' προϊόντα';
    }
    var _countWord = _isIt() ? _itCountWord(list.length)
                   : _isHr() ? _hrCountWord(list.length)
                   : _isGr() ? _grCountWord(list.length)
                   : _isSi() ? _siCountWord(list.length)
                   : _isDe() ? ' Produkte'
                   : ' produktov';
    var frags = [];
    frags.push(
      '<div class="artmie-wishlist-toolbar">' +
        '<div class="artmie-wishlist-toolbar__count">' + list.length + _countWord + '</div>' +
        '<button type="button" class="artmie-wishlist-addall button button-primary" data-wishlist-add-all>' +
          _t('Pridať všetky do košíka') +
        '</button>' +
      '</div>'
    );
    frags.push('<div class="artmie-wishlist-grid">');
    for (var i = 0; i < list.length; i++) {
      frags.push(renderCard(list[i]));
    }
    frags.push('</div>');
    var newHtml = frags.join('');
    if (host.innerHTML !== newHtml) host.innerHTML = newHtml;

    list.forEach(function (item) { hydrateCard(item.handle); });
  }

  function renderCard(it) {
    /* ARTMIE_WISHLIST_UNAVAIL_RENDER 2026-05-19 — if hydrateCard previously
       discovered this handle is gone, render the disabled state directly so
       paint output matches what hydrateCard would produce, ending the flash. */
    var unavailable = !!unavailableHandles[it.handle];
    var imgHtml = it.image
      ? '<img src="' + escapeAttr(it.image) + '" alt="" loading="lazy" class="artmie-wishlist-card__image">'
      : '<div class="artmie-wishlist-card__image artmie-wishlist-card__image--placeholder"></div>';
    var priceHtml = unavailable
      ? '<div class="artmie-wishlist-card__price" data-wishlist-card-price><span style="color:#a33;font-weight:500;font-size:13px">' + escapeHtml(_t('Produkt už nie je dostupný')) + '</span></div>'
      : (it.price
          ? '<div class="artmie-wishlist-card__price" data-wishlist-card-price>' + escapeHtml(it.price) + '</div>'
          : '<div class="artmie-wishlist-card__price" data-wishlist-card-price>…</div>');
    var brandHtml = it.brand
      ? '<div class="artmie-wishlist-card__brand">' + escapeHtml(it.brand) + '</div>'
      : '<div class="artmie-wishlist-card__brand" data-wishlist-card-brand></div>';
    var ratingHtml = '<div class="artmie-wishlist-card__rating" data-wishlist-card-rating>' + renderStars(it.rating, it.ratingCount) + '</div>';

    var variantHtml = '<div class="artmie-wishlist-card__variants" data-wishlist-card-variants></div>';
    var qty = Math.max(1, parseInt(it.qty || 1, 10) || 1);
    var addBtnText = unavailable ? _tNotAvail() : _t('Do košíka');
    var addBtnAttrs = unavailable ? ' disabled' : '';
    var cardClass = 'artmie-wishlist-card' + (unavailable ? ' is-unavailable' : '');

    return (
      '<div class="' + cardClass + '" data-wishlist-item="' + escapeAttr(it.handle) + '">' +
        '<button type="button" class="artmie-wishlist-card__remove" ' +
          'data-wishlist-toggle data-wishlist-handle="' + escapeAttr(it.handle) + '" ' +
          'data-wishlist-title="' + escapeAttr(it.title) + '" aria-label="' + escapeAttr(_t('Odstrániť')) + '">' +
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<a href="/products/' + escapeAttr(it.handle) + '" class="artmie-wishlist-card__link">' +
          imgHtml +
          brandHtml +
          ratingHtml +
          '<h3 class="artmie-wishlist-card__title">' + escapeHtml(it.title) + '</h3>' +
        '</a>' +
        priceHtml +
        variantHtml +
        '<div class="artmie-wishlist-card__controls">' +
          '<div class="artmie-wishlist-card__qty">' +
            '<button type="button" class="artmie-qty-btn" data-wishlist-qty-dec aria-label="' + escapeAttr(_t('Znížiť')) + '">−</button>' +
            '<input type="number" min="1" max="99" value="' + qty + '" ' +
              'class="artmie-qty-input" data-wishlist-qty-input data-wishlist-handle="' + escapeAttr(it.handle) + '">' +
            '<button type="button" class="artmie-qty-btn" data-wishlist-qty-inc aria-label="' + escapeAttr(_t('Zvýšiť')) + '">+</button>' +
          '</div>' +
          '<button type="button" class="artmie-wishlist-card__add button button-primary" ' +
            'data-wishlist-add data-wishlist-handle="' + escapeAttr(it.handle) + '"' + addBtnAttrs + '>' +
            addBtnText +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function hydrateCard(handle) {
    fetchProduct(handle).then(function (p) {
      var card = document.querySelector('[data-wishlist-item="' + cssEsc(handle) + '"]');
      if (!card) return;
      if (!p) {
        /* fetchProduct already set unavailableHandles[handle]=true so the next
           paint will emit the disabled markup. Apply the same changes now so
           the user sees the disabled state immediately rather than waiting
           up to 1500ms for the next interval tick. */
        if (!card.classList.contains('is-unavailable')) card.classList.add('is-unavailable');
        var priceEl = card.querySelector('[data-wishlist-card-price]');
        var priceHtml = '<span style="color:#a33;font-weight:500;font-size:13px">' + escapeHtml(_t('Produkt už nie je dostupný')) + '</span>';
        if (priceEl && priceEl.innerHTML !== priceHtml) priceEl.innerHTML = priceHtml;
        var addBtn = card.querySelector('[data-wishlist-add]');
        var notAvail = _tNotAvail();
        if (addBtn) {
          if (!addBtn.disabled) addBtn.disabled = true;
          if (addBtn.textContent !== notAvail) addBtn.textContent = notAvail;
        }
        var varsEl = card.querySelector('[data-wishlist-card-variants]');
        if (varsEl && varsEl.innerHTML !== '') varsEl.innerHTML = '';
        return;
      }
      var item = load().find(function (i) { return i.handle === handle; });
      if (!item) return;

      var priceEl = card.querySelector('[data-wishlist-card-price]');
      var varsEl = card.querySelector('[data-wishlist-card-variants]');

      if (p.variants && p.variants.length > 1) {
        var currentId = item.variantId || p.variants[0].id;
        var currentVariant = p.variants.find(function (v) { return String(v.id) === String(currentId); }) || p.variants[0];
        var thumb = variantImage(p, currentVariant);
        var thumbHtml = thumb
          ? '<img src="' + escapeAttr(thumb) + '" alt="" class="artmie-wishlist-card__variant-thumb">'
          : '<span class="artmie-wishlist-card__variant-thumb artmie-wishlist-card__variant-thumb--placeholder"></span>';
        if (varsEl) {
          varsEl.innerHTML =
            '<label class="artmie-wishlist-card__variant-label">Variant:</label>' +
            '<button type="button" class="artmie-wishlist-card__variant-picker" ' +
              'data-wishlist-change-variant data-wishlist-handle="' + escapeAttr(handle) + '">' +
              thumbHtml +
              '<span class="artmie-wishlist-card__variant-picker-name">' + escapeHtml(cleanVariantTitle(currentVariant.title, p.title)) + '</span>' +
              '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
            '</button>';
        }
      } else if (varsEl) {
        varsEl.innerHTML = '';
      }

      if (priceEl) {
        var variantId = item.variantId || (p.variants && p.variants[0] && p.variants[0].id);
        var variant = (p.variants || []).find(function (v) { return String(v.id) === String(variantId); }) || p.variants[0];
        if (variant) priceEl.textContent = formatMoney(variant.price);
      }

      // Refresh image from CURRENT product data — the URL stored when the user saved
      // the item may now 404 if the merchant re-uploaded the image.
      var imgEl = card.querySelector('img.artmie-wishlist-card__image');
      var freshVariantId = item.variantId || (p.variants && p.variants[0] && p.variants[0].id);
      var freshVariant = (p.variants || []).find(function (v) { return String(v.id) === String(freshVariantId); }) || p.variants[0];
      var freshImg = variantImage(p, freshVariant);
      if (freshImg && imgEl) {
        // If the existing img is broken or stale, swap it
        if (!imgEl.complete || imgEl.naturalWidth === 0 || imgEl.src !== freshImg) {
          imgEl.onload = function () { updateItem(handle, { image: freshImg }); };
          imgEl.onerror = function () { /* leave; renderPage will retry next paint */ };
          imgEl.src = freshImg;
        }
      } else if (freshImg && !imgEl) {
        // Card had no img (placeholder shown). Replace placeholder with fresh image.
        var place = card.querySelector('.artmie-wishlist-card__image--placeholder');
        if (place) {
          var newImg = document.createElement('img');
          newImg.className = 'artmie-wishlist-card__image';
          newImg.alt = '';
          newImg.loading = 'lazy';
          newImg.onload = function () { updateItem(handle, { image: freshImg }); };
          newImg.src = freshImg;
          place.parentNode.replaceChild(newImg, place);
        }
      }
    });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Chyba'); });
      return r.json();
    });
  }

  function handleAddAll(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    btn.disabled = true;
    btn.textContent = _t('Pridávam…');
    var list = load();
    var chain = Promise.resolve();
    var added = 0, failed = 0;
    list.forEach(function (item) {
      chain = chain.then(function () {
        var card = document.querySelector('[data-wishlist-item="' + cssEsc(item.handle) + '"]');
        var qtyInput = card && card.querySelector('[data-wishlist-qty-input]');
        var selEl = card && card.querySelector('[data-wishlist-variant]');
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : (item.qty || 1);
        return fetchProduct(item.handle).then(function (p) {
          var vid = (selEl && selEl.value) || item.variantId || (p && p.variants && p.variants[0] && p.variants[0].id);
          if (!vid) { failed++; return; }
          return addToCart(vid, qty).then(function () { added++; }).catch(function () { failed++; });
        });
      });
    });
    chain.then(function () {
      btn.disabled = false;
      btn.textContent = _tAdded(added, failed);
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        btn.textContent = _t('Pridať všetky do košíka');
      }, 2500);
    });
  }

  function handleAddOne(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var handle = btn.getAttribute('data-wishlist-handle');
    var card = document.querySelector('[data-wishlist-item="' + cssEsc(handle) + '"]');
    var qtyInput = card && card.querySelector('[data-wishlist-qty-input]');
    var selEl = card && card.querySelector('[data-wishlist-variant]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var item = load().find(function (i) { return i.handle === handle; });
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = _t('Pridávam…');
    fetchProduct(handle).then(function (p) {
      var vid = (selEl && selEl.value) || (item && item.variantId) || (p && p.variants && p.variants[0] && p.variants[0].id);
      if (!vid) throw new Error(_t('žiadny variant'));
      return addToCart(vid, qty);
    }).then(function () {
      btn.textContent = _isDe() ? 'Hinzugefügt ✓' : 'Pridané ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 2000);
    }).catch(function (err) {
      btn.textContent = _isSi() ? 'Napaka' : (_isDe() ? 'Fehler' : 'Chyba');
      setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 2500);
    });
  }

  function handleVariantChange(e) {
    var sel = e.target.closest ? e.target.closest('[data-wishlist-variant]') : null;
    if (!sel) return;
    var handle = sel.getAttribute('data-wishlist-handle');
    var vid = sel.value;
    updateItem(handle, { variantId: vid });
    var card = sel.closest('[data-wishlist-item]');
    if (card) {
      var priceEl = card.querySelector('[data-wishlist-card-price]');
      fetchProduct(handle).then(function (p) {
        var variant = (p && p.variants || []).find(function (v) { return String(v.id) === String(vid); });
        if (variant && priceEl) priceEl.textContent = formatMoney(variant.price);
      });
    }
  }

  function handleQtyBtn(e, dir) {
    var btn = e.target.closest ? e.target.closest(dir > 0 ? '[data-wishlist-qty-inc]' : '[data-wishlist-qty-dec]') : null;
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('[data-wishlist-qty-input]');
    if (!input) return;
    var cur = Math.max(1, parseInt(input.value, 10) || 1);
    var next = Math.max(1, Math.min(99, cur + dir));
    if (next !== cur) {
      input.value = next;
      updateItem(input.getAttribute('data-wishlist-handle'), { qty: next });
    }
  }

  function handleQtyInput(e) {
    var input = e.target.closest ? e.target.closest('[data-wishlist-qty-input]') : null;
    if (!input) return;
    var v = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1));
    input.value = v;
    updateItem(input.getAttribute('data-wishlist-handle'), { qty: v });
  }

  function openVariantPicker(item, product, mode) {
    mode = mode || 'save';
    closeVariantPicker();
    var overlay = document.createElement('div');
    overlay.className = 'artmie-wl-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="artmie-wl-modal__backdrop" data-wl-modal-close></div>' +
      '<div class="artmie-wl-modal__dialog">' +
        '<button type="button" class="artmie-wl-modal__close" data-wl-modal-close aria-label="' + escapeAttr(_t('Zavrieť')) + '">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<h2 class="artmie-wl-modal__title">' + escapeHtml(_t('Vyber variant')) + '</h2>' +
        '<p class="artmie-wl-modal__subtitle">' + escapeHtml(item.title) + '</p>' +
        '<ul class="artmie-wl-modal__variants">' +
          product.variants.slice().sort(function (a, b) {
            if (a.available === b.available) return 0;
            return a.available ? -1 : 1;
          }).map(function (v) {
            var price = formatMoney(v.price);
            var imgSrc = variantImage(product, v);
            var imgHtml = imgSrc
              ? '<img class="artmie-wl-modal__variant-img" src="' + escapeAttr(imgSrc) + '" alt="" loading="lazy">'
              : '<span class="artmie-wl-modal__variant-img artmie-wl-modal__variant-img--placeholder"></span>';
            return '<li class="artmie-wl-modal__variant' + (v.available ? '' : ' is-unavailable') + '">' +
              '<button type="button" class="artmie-wl-modal__variant-btn" ' +
                'data-wl-pick-variant="' + v.id + '" ' + (v.available ? '' : 'disabled') + '>' +
                imgHtml +
                '<span class="artmie-wl-modal__variant-body">' +
                  '<span class="artmie-wl-modal__variant-title">' + escapeHtml(cleanVariantTitle(v.title, product.title)) + '</span>' +
                  '<span class="artmie-wl-modal__variant-meta">' +
                    '<span class="artmie-wl-modal__variant-price">' + price + '</span>' +
                    (v.available ? '' : '<span class="artmie-wl-modal__variant-oos">nie je skladom</span>') +
                  '</span>' +
                '</span>' +
              '</button>' +
            '</li>';
          }).join('') +
        '</ul>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.classList.add('artmie-wl-modal-open');
    var firstBtn = overlay.querySelector('.artmie-wl-modal__variant-btn:not([disabled])');
    if (firstBtn) firstBtn.focus();

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-wl-modal-close]')) { closeVariantPicker(); return; }
      var pickBtn = e.target.closest('[data-wl-pick-variant]');
      if (pickBtn) {
        var vid = pickBtn.getAttribute('data-wl-pick-variant');
        var variant = product.variants.find(function (v) { return String(v.id) === String(vid); });
        if (!variant) return;
        var patch = {
          variantId: vid,
          price: formatMoney(variant.price),
          image: variantImage(product, variant) || item.image
        };
        if (mode === 'change') {
          updateItem(item.handle, patch);
        } else {
          var full = Object.assign({}, item, patch);
          toggle(full);
        }
        closeVariantPicker();
      }
    });
    document.addEventListener('keydown', escCloseModal);
  }
  function closeVariantPicker() {
    var existing = document.querySelector('.artmie-wl-modal');
    if (existing) existing.remove();
    document.body.classList.remove('artmie-wl-modal-open');
    document.removeEventListener('keydown', escCloseModal);
  }
  function escCloseModal(e) { if (e.key === 'Escape') closeVariantPicker(); }

  function onClick(e) {
    var all = e.target.closest ? e.target.closest('[data-wishlist-add-all]') : null;
    if (all) { handleAddAll({ preventDefault: function () {}, stopPropagation: function () {}, currentTarget: all }); return; }
    var add = e.target.closest ? e.target.closest('[data-wishlist-add]') : null;
    if (add) { handleAddOne({ preventDefault: function () {}, stopPropagation: function () {}, currentTarget: add }); return; }
    if (e.target.closest && e.target.closest('[data-wishlist-qty-inc]')) { handleQtyBtn(e, +1); return; }
    if (e.target.closest && e.target.closest('[data-wishlist-qty-dec]')) { handleQtyBtn(e, -1); return; }
    var chgBtn = e.target.closest ? e.target.closest('[data-wishlist-change-variant]') : null;
    if (chgBtn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = chgBtn.getAttribute('data-wishlist-handle');
      var item = load().find(function (i) { return i.handle === handle; });
      if (!item) return;
      fetchProduct(handle).then(function (p) {
        if (p && p.variants && p.variants.length > 1) openVariantPicker(item, p, 'change');
      });
      return;
    }
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      var item = {
        handle: btn.getAttribute('data-wishlist-handle'),
        title: btn.getAttribute('data-wishlist-title') || '',
        url: btn.getAttribute('data-wishlist-url') || ('/products/' + btn.getAttribute('data-wishlist-handle')),
        image: btn.getAttribute('data-wishlist-image') || '',
        price: btn.getAttribute('data-wishlist-price') || '',
        brand: btn.getAttribute('data-wishlist-brand') || '',
        rating: btn.getAttribute('data-wishlist-rating') || '',
        ratingCount: btn.getAttribute('data-wishlist-rating-count') || '',
        variantId: btn.getAttribute('data-wishlist-variant-id') || null
      };
      if (!item.handle) return;
      if (has(item.handle)) { toggle(item); return; }
      var inWishlistPage = !!btn.closest('#artmie-wishlist-page');
      if (inWishlistPage) { toggle(item); return; }
      if (btn.getAttribute('data-wishlist-available') === 'false') {
        showToast(_t('Produkt je vypredaný'));
        return;
      }
      fetchProduct(item.handle).then(function (p) {
        if (!p) { toggle(item); return; }
        var anyAvailable = (p.variants || []).some(function (v) { return v.available; });
        if (!anyAvailable) { showToast(_t('Produkt je vypredaný')); return; }
        if (p.variants.length > 1) openVariantPicker(item, p);
        else toggle(item);
      }).catch(function () { toggle(item); });
    }
  }

  function onEarly(e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }

  function renderStars(rating, count) {
    var r = parseFloat(rating);
    var c = parseInt(count, 10);
    if (!isFinite(r) || r <= 0 || !isFinite(c) || c <= 0) return '';
    var full = Math.round(r);
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += '<svg class="artmie-wl-star' + (i <= full ? ' is-on' : '') + '" viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.02l-4.94 2.68.94-5.49-4-3.9 5.53-.8z"/></svg>';
    }
    return stars + '<span class="artmie-wl-rating-count">(' + c + ')</span>';
  }

  function showToast(msg) {
    var existing = document.querySelector('.artmie-wl-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.className = 'artmie-wl-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-out'); }, 2200);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2700);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }
  function cssEsc(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  document.addEventListener('mousedown', onEarly, true);
  document.addEventListener('touchstart', onEarly, { capture: true, passive: false });
  document.addEventListener('click', onClick, true);
  document.addEventListener('change', handleVariantChange);
  document.addEventListener('input', handleQtyInput);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
  document.addEventListener('shopify:section:load', function () { paint(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint, { once: true });
  } else {
    paint();
  }
  window.addEventListener('pageshow', paint);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) paint(); });
  setInterval(paint, 1500);

  window.ArtmieWishlist = { load: load, toggle: toggle, has: has, paint: paint, addToCart: addToCart };
})();
